import { render, staticRenderFns } from "./acceptanceLogin.vue?vue&type=template&id=2fe4f040&scoped=true"
import script from "./acceptanceLogin.vue?vue&type=script&lang=js"
export * from "./acceptanceLogin.vue?vue&type=script&lang=js"
import style0 from "./acceptanceLogin.vue?vue&type=style&index=0&id=2fe4f040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe4f040",
  null
  
)

export default component.exports